/* Confo.Inno · Hero : squelette postural, lignes de pression, cartes de données.
   Repris de la maquette approuvée (design/maquette-accueil/app.js) :
   - cycle de posture : affaissé → micro-mouvement → redressé → retour lent (durée réglable) ;
   - respiration du squelette sur 6 s ;
   - lignes de pression centrées sous le coussin, jusqu'aux bords de l'écran ;
   - parallaxe à trois couches à la souris (ordinateur seulement).
   Élément personnalisé : il se réinitialise seul quand l'éditeur de thème recharge la section. */
(function () {
  'use strict';
  if (customElements.get('ci-hero')) return;

  var NS = 'http://www.w3.org/2000/svg';
  var C = { vert: [0, 210, 106], bleu: [5, 117, 230], corail: [255, 90, 54] };
  var mix = function (a, b, t) { return a.map(function (v, i) { return Math.round(v + (b[i] - v) * t); }); };
  var rgb = function (c, o) { return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + (o == null ? 1 : o) + ')'; };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var svgEl = function (parent, n, a) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); parent.appendChild(e); return e; };

  // Postures en coordonnées du viewBox 560 × 640
  var AFFAISSE = { head: [288, 98], neck: [272, 170], sh: [279, 210], t8: [256, 300], l3: [252, 388], hip: [266, 452] };
  var DROIT = { head: [254, 91], neck: [262, 166], sh: [270, 208], t8: [263, 296], l3: [260, 386], hip: [266, 452] };
  var FIXE = { elb: [318, 326], wr: [444, 332], knee: [432, 458], ank: [426, 612] };
  var CYCLE_BASE = 13; // le cycle d'origine (s) dont on garde les proportions

  function posture(t) {
    var c = t % CYCLE_BASE;
    if (c < 6) return 0;
    if (c < 7.2) return ease((c - 6) / 1.2);
    if (c < 10) return 1;
    if (c < 12.5) return 1 - ease((c - 10) / 2.5);
    return 0;
  }

  class CiHero extends HTMLElement {
    connectedCallback() {
      this.scene = this.querySelector('.ci-hero__scene');
      this.svg = this.querySelector('.ci-hero__squelette');
      this.cv = this.querySelector('.ci-hero__lignes canvas');
      if (!this.scene || !this.svg || !this.cv) return;
      this.ctx = this.cv.getContext('2d');
      this.vitesse = CYCLE_BASE / (parseFloat(this.dataset.duree) || 9.1);
      this.anime = !this.hasAttribute('data-fixe') && window.ConfoInno && window.ConfoInno.mouvement();

      this.construireSquelette();
      this.cartes = [1, 2, 3].map((n) => this.querySelector('.ci-hero__carte--' + n));
      var c3 = this.cartes[2];
      this.textes3 = {
        libelle: c3.dataset.libelle, moment: c3.dataset.libelleMoment,
        valeur: c3.dataset.valeur, maintenant: c3.dataset.valeurMoment
      };

      this.W = this.H = this.SX = this.SY = 0; this.SW = this.SH = 1;
      this.taille = this.taille.bind(this);
      this.ro = new ResizeObserver(this.taille);
      this.ro.observe(this.cv); this.ro.observe(this.scene);
      this.taille();
      this.dessine(0, false);

      if (this.anime) this.demarrer();
      else if (window.ConfoInno) window.ConfoInno.reveler(this);
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (this.io) this.io.disconnect();
      if (this.tick && window.gsap) window.gsap.ticker.remove(this.tick);
      if (this.onMove) window.removeEventListener('pointermove', this.onMove);
      if (this.split) this.split.revert();
      if (this.entree) this.entree.kill();
    }

    construireSquelette() {
      var svg = this.svg;
      svg.textContent = '';
      svgEl(svg, 'rect', { x: 190, y: 470, width: 190, height: 26, rx: 13, fill: 'rgba(5,117,230,.18)', stroke: '#0575E6', 'stroke-width': 1.5, 'stroke-dasharray': '6 5' });
      var coussin = svg.dataset.coussin;
      if (coussin) { var tb = svgEl(svg, 'text', { x: 196, y: 530, 'class': 'tag', fill: '#0575E6' }); tb.textContent = coussin; }
      this.lignes = [0, 1, 2].map(function () { return svgEl(svg, 'polyline', { fill: 'none', stroke: '#00D26A', 'stroke-width': 2, 'stroke-linejoin': 'round', 'stroke-opacity': 0.9 }); });
      this.tete = svgEl(svg, 'circle', { r: 32, fill: 'none', stroke: '#00D26A', 'stroke-width': 2 });
      this.pts = {};
      ['neck', 'sh', 't8', 'l3', 'hip', 'elb', 'wr', 'knee', 'ank'].forEach((k) => {
        this.pts[k] = { ring: svgEl(svg, 'circle', { r: 13, fill: 'none', 'stroke-width': 1 }), dot: svgEl(svg, 'circle', { r: 4.5 }) };
      });
      this.tags = { sh: svgEl(svg, 'text', { 'class': 'tag' }), t8: svgEl(svg, 'text', { 'class': 'tag' }), l3: svgEl(svg, 'text', { 'class': 'tag' }) };
    }

    taille() {
      var r = this.cv.getBoundingClientRect(), sr = this.scene.getBoundingClientRect();
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      this.W = r.width; this.H = r.height;
      this.SX = sr.left - r.left; this.SY = sr.top - r.top; this.SW = sr.width || 1; this.SH = sr.height || 1;
      this.cv.width = this.W * dpr; this.cv.height = this.H * dpr;
      this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (!this.anime) this.dessine(0, false);
    }

    blob(cx, cy, R, sx, seed, t) {
      var ctx = this.ctx;
      ctx.beginPath();
      for (var i = 0; i <= 120; i++) {
        var a = (i / 120) * Math.PI * 2;
        var w = 0.09 * Math.sin(3 * a + seed + 0.35 * Math.sin(t * 0.5 + seed)) + 0.05 * Math.cos(5 * a - seed * 1.3) + 0.03 * Math.sin(7 * a + seed * 2 + t * 0.3);
        var r = R * (1 + w), x = cx + r * Math.cos(a) * sx, y = cy + r * Math.sin(a);
        if (i) ctx.lineTo(x, y); else ctx.moveTo(x, y);
      }
      ctx.closePath();
      ctx.stroke();
    }

    fond(t, p) {
      var ctx = this.ctx, W = this.W, H = this.H, SX = this.SX, SY = this.SY, SW = this.SW, SH = this.SH;
      ctx.clearRect(0, 0, W, H);
      // Trame de capteurs sur le panneau de la scène, en fondu vers la gauche (aucune ligne de séparation)
      var g = (SW / 860) * 22, x0 = SX - SW * 0.1, fade = SW * 0.45;
      if (SW >= W * 0.95) {
        // Scène empilée sous le texte (mobile) : la trame apparaît en fondu vers le bas, sans bord net
        g = Math.max(g, 14);
        var y0 = SY - SH * 0.25, fadeY = SH * 0.5;
        for (var yy = y0 + g / 2; yy < H; yy += g) {
          ctx.fillStyle = 'rgba(255,255,255,' + (0.07 * Math.min(1, Math.max(0, (yy - y0) / fadeY))).toFixed(3) + ')';
          for (var xx = g / 2; xx < W; xx += g) ctx.fillRect(xx, yy, 1.6, 1.6);
        }
      } else {
        for (var x = x0 + g / 2; x < W; x += g) {
          ctx.fillStyle = 'rgba(255,255,255,' + (0.07 * Math.min(1, Math.max(0, (x - x0) / fade))).toFixed(3) + ')';
          for (var y = SY + g / 2; y < SY + SH; y += g) ctx.fillRect(x, y, 1.6, 1.6);
        }
      }
      // Lignes de pression centrées sous le coussin, jusqu'aux bords de l'écran
      var cx = SX + SW * 0.364, cy = SY + SH * 0.628, s = (SW / 860) * 1.25;
      var loin = Math.max(cx, W - cx, cy, H - cy) * 1.15;
      var br = Math.sin((t * 2 * Math.PI) / 6) * 0.015;
      for (var i = 0; i < 5; i++) {
        var R = (18 + i * 16) * s * (1 + br * (1 + i * 0.3)), chaud = i < 2;
        var c = chaud ? mix(C.corail, C.vert, p) : C.bleu, o = chaud ? (1 - i * 0.3) * 0.55 : (0.8 - (i - 2) * 0.2) * 0.45;
        ctx.strokeStyle = rgb(c, o); ctx.lineWidth = 1.2;
        var sp = lerp(70, 62, p) * s;
        this.blob(cx - sp, cy, R, 1, 1 + i * 0.4, t);
        this.blob(cx + sp, cy, R, 1, 2.3 + i * 0.35, t);
      }
      for (var j = 0; (120 + j * 26) * s < loin; j++) {
        var R2 = (120 + j * 26) * s * (1 + br * (0.6 + Math.min(j, 8) * 0.15)), c2 = j < 3 ? C.bleu : C.vert;
        var o2 = (j < 3 ? 0.5 - j * 0.1 : Math.max(0.22, 0.7 - (j - 3) * 0.08)) * 0.45;
        ctx.strokeStyle = rgb(c2, Math.max(o2, 0.05)); ctx.lineWidth = 1.1;
        this.blob(cx, cy, R2, 1.35, 0.7 + j * 0.3, t);
      }
    }

    dessine(t, anime) {
      var tc = t * this.vitesse, p = anime ? posture(tc) : 0, br = anime ? Math.sin((t * 2 * Math.PI) / 6) : 0, P = {}, k;
      for (k in AFFAISSE) P[k] = [lerp(AFFAISSE[k][0], DROIT[k][0], p), lerp(AFFAISSE[k][1], DROIT[k][1], p)];
      for (k in FIXE) P[k] = FIXE[k];
      ['head', 'neck', 'sh', 't8'].forEach(function (k, i) { P[k] = [P[k][0] + br * (3 - i * 0.6), P[k][1] - br * (2.2 - i * 0.4)]; });
      var L = function (a) { return a.map(function (k) { return P[k].join(','); }).join(' '); };
      this.lignes[0].setAttribute('points', L(['neck', 'sh', 't8', 'l3', 'hip']));
      this.lignes[1].setAttribute('points', L(['sh', 'elb', 'wr']));
      this.lignes[2].setAttribute('points', L(['hip', 'knee', 'ank']));
      this.tete.setAttribute('cx', P.head[0]); this.tete.setAttribute('cy', P.head[1]);
      for (k in this.pts) {
        var risque = k === 't8' || k === 'l3', c = risque ? mix(C.corail, C.vert, p) : C.vert;
        this.pts[k].ring.setAttribute('cx', P[k][0]); this.pts[k].ring.setAttribute('cy', P[k][1]); this.pts[k].ring.setAttribute('stroke', rgb(c, 0.4));
        this.pts[k].dot.setAttribute('cx', P[k][0]); this.pts[k].dot.setAttribute('cy', P[k][1]); this.pts[k].dot.setAttribute('fill', rgb(c));
      }
      var txt = { sh: 'C7 · ' + Math.round(lerp(14, 8, p)) + '°', t8: 'T8 · ' + Math.round(lerp(38, 22, p)) + '°', l3: 'L3 · ' + Math.round(lerp(9, 14, p)) + '°' };
      for (k in this.tags) {
        var ct = k === 'sh' ? C.vert : mix(C.corail, C.vert, p);
        this.tags[k].textContent = txt[k];
        this.tags[k].setAttribute('x', P[k][0] - 160); this.tags[k].setAttribute('y', P[k][1] + 5); this.tags[k].setAttribute('fill', rgb(ct));
      }

      // Cartes : indice postural, temps assis, prochain micro-mouvement
      var c1 = this.cartes[0], c2 = this.cartes[1], c3 = this.cartes[2];
      var indice = Math.round(lerp(72, 86, p));
      c1.querySelector('[data-v]').textContent = indice + ' / 100';
      c1.querySelector('[data-b]').style.width = indice + '%';
      var cy = tc % CYCLE_BASE;
      var min = !anime ? 108 : (cy < 6.6 ? 108 + Math.floor(cy * 1.5) : Math.max(0, Math.round((cy - 6.6) * 0.6)));
      c2.querySelector('[data-v]').textContent = min >= 60 ? Math.floor(min / 60) + ' h ' + String(min % 60).padStart(2, '0') : min + ' min';
      c2.querySelector('[data-b]').style.width = Math.min(100, (min / 130) * 100) + '%';
      var moment = anime && cy >= 5.4 && cy < 7.8;
      c3.classList.toggle('is-moment', moment);
      c3.querySelector('[data-l]').textContent = moment ? this.textes3.moment : this.textes3.libelle;
      c3.querySelector('[data-v]').textContent = moment ? this.textes3.maintenant : this.textes3.valeur;
      var b3 = c3.querySelector('[data-b]');
      b3.style.width = (moment ? 100 : 40) + '%';
      b3.style.background = moment ? 'var(--ci-vert)' : 'var(--ci-bleu)';

      this.fond(anime ? t : 0, p);
    }

    demarrer() {
      var gsap = window.gsap, self = this;
      var couches = Array.prototype.slice.call(this.querySelectorAll('.ci-hero__couche, .ci-hero__lignes'));
      var bureau = window.matchMedia('(min-width: 981px) and (pointer: fine)');
      var tx = 0, ty = 0, sx = 0, sy = 0, visible = true;

      this.onMove = function (e) {
        if (e.pointerType !== 'mouse' || !bureau.matches) return;
        var r = self.scene.getBoundingClientRect();
        tx = Math.max(-1, Math.min(1, (e.clientX - (r.left + r.width / 2)) / (r.width / 2)));
        ty = Math.max(-1, Math.min(1, (e.clientY - (r.top + r.height / 2)) / (r.height / 2)));
      };
      window.addEventListener('pointermove', this.onMove);

      // Pause hors écran
      this.io = new IntersectionObserver(function (entrees) { visible = entrees[0].isIntersecting; });
      this.io.observe(this);

      var t0 = performance.now();
      this.tick = function () {
        if (!visible) return;
        var t = (performance.now() - t0) / 1000;
        sx += (tx - sx) * 0.06; sy += (ty - sy) * 0.06;
        couches.forEach(function (el) {
          var d = parseFloat(el.dataset.p);
          el.style.transform = 'translate3d(' + (-sx * d * 18).toFixed(2) + 'px,' + (-sy * d * 14).toFixed(2) + 'px,0)';
        });
        self.dessine(t, true);
      };
      gsap.ticker.add(this.tick);

      // Entrée : pas dans l'éditeur de thème, pour que le client voie toujours son contenu
      if (window.ConfoInno.designMode) { window.ConfoInno.reveler(this); return; }
      document.fonts.ready.then(function () {
        if (!self.isConnected) return;
        window.ConfoInno.reveler(self);
        var tl = gsap.timeline({ defaults: { ease: 'power3.out', duration: 0.8 } });
        var texte = Array.prototype.slice.call(self.querySelectorAll('.ci-hero__texte > *'));
        var titre = self.querySelector('[data-ci-titre-mots]');
        texte.forEach(function (el, i) {
          if (el === titre && window.SplitText) {
            self.split = window.SplitText.create(titre, { type: 'lines,words', mask: 'lines' });
            tl.from(self.split.words, { yPercent: 110, duration: 0.9, stagger: 0.035 }, 0.1);
          } else {
            tl.from(el, { y: i === 0 ? 16 : 24, autoAlpha: 0 }, i === 0 ? 0 : 0.3 + i * 0.12);
          }
        });
        tl.from(self.querySelectorAll('.ci-hero__carte'), { y: 20, autoAlpha: 0, stagger: 0.12, duration: 0.7 }, 0.5)
          .from(self.svg, { autoAlpha: 0, duration: 1.2 }, 0.3);
        self.entree = tl;
      });
    }
  }

  customElements.define('ci-hero', CiHero);
})();
